var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _circle2, _path9, _circle3, _path10, _circle4, _circle5, _circle6, _circle7, _path11, _path12, _path13, _path14, _path15, _circle8, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: "100%",
    height: "100%",
    viewBox: "0 0 744.848 747.077",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "m71.629 629.348-6.56-25.872a335.967 335.967 0 0 0-35.643-12.788l-.828 12.024-3.358-13.247C10.219 585.171 0 583.282 0 583.282s13.8 52.489 42.754 92.617l33.734 5.926-26.207 3.779A135.926 135.926 0 0 0 62 698.026c42.115 39.092 89.024 57.028 104.773 40.06s-5.625-62.412-47.74-101.5c-13.056-12.12-29.457-21.844-45.875-29.5Z",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "m134.015 601.245 7.758-25.538a335.94 335.94 0 0 0-23.9-29.37l-6.924 9.864 3.972-13.076c-10.641-11.436-18.412-18.335-18.412-18.335s-15.315 52.067-11.275 101.384l25.815 22.51-24.392-10.312a135.919 135.919 0 0 0 3.614 16.694c15.846 55.234 46.731 94.835 68.983 88.451s27.446-56.335 11.6-111.569c-4.912-17.123-13.926-33.926-24.023-48.965Z",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22",
    d: "M519.751 176.984h-4.092v-112.1A64.883 64.883 0 0 0 450.776.001H213.269a64.883 64.883 0 0 0-64.883 64.883v615a64.883 64.883 0 0 0 64.883 64.883h237.507a64.883 64.883 0 0 0 64.882-64.883V256.778h4.092Z",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23",
    d: "M453.394 16.874h-31a23.02 23.02 0 0 1-21.316 31.715H265.013a23.02 23.02 0 0 1-21.314-31.715h-28.956a48.454 48.454 0 0 0-48.454 48.455v614.106a48.454 48.454 0 0 0 48.454 48.454h238.651a48.454 48.454 0 0 0 48.454-48.454V65.329a48.454 48.454 0 0 0-48.454-48.453Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6",
    d: "M303.658 261.504a24.437 24.437 0 0 1 12.23-21.174 24.45 24.45 0 1 0 0 42.345 24.434 24.434 0 0 1-12.23-21.171Z",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7",
    d: "M334.395 261.504a24.436 24.436 0 0 1 12.23-21.174 24.45 24.45 0 1 0 0 42.345 24.434 24.434 0 0 1-12.23-21.171Z",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 364.434,
    cy: 261.502,
    r: 24.45,
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M405.296 337.869h-142.5a5.123 5.123 0 0 1-5.117-5.117v-142.5a5.123 5.123 0 0 1 5.117-5.117h142.5a5.123 5.123 0 0 1 5.117 5.117v142.5a5.123 5.123 0 0 1-5.117 5.117Zm-142.5-150.686a3.073 3.073 0 0 0-3.07 3.07v142.5a3.073 3.073 0 0 0 3.07 3.07h142.5a3.073 3.073 0 0 0 3.07-3.07v-142.5a3.073 3.073 0 0 0-3.07-3.07Z",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1",
    fill: "#ccc",
    d: "M218.562 447.102h218.552v2.047H218.562z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2",
    cx: 225.464,
    cy: 427.42,
    r: 6.902,
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2",
    fill: "#ccc",
    d: "M218.562 516.118h218.552v2.047H218.562z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3",
    cx: 225.464,
    cy: 496.437,
    r: 6.902,
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M433.114 594.71h-69.068a4.505 4.505 0 0 1-4.5-4.5v-24.208a4.505 4.505 0 0 1 4.5-4.5h69.068a4.505 4.505 0 0 1 4.5 4.5v24.208a4.505 4.505 0 0 1-4.5 4.5Z",
    fill: "#6c63ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 247.978,
    cy: 427.42,
    r: 6.902,
    fill: "#6c63ff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 270.492,
    cy: 427.42,
    r: 6.902,
    fill: "#6c63ff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 9",
    cx: 247.978,
    cy: 496.437,
    r: 6.902,
    fill: "#6c63ff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 10",
    cx: 270.492,
    cy: 496.437,
    r: 6.902,
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 88",
    d: "M742.066 747.078H24.08c-1.537 0-2.782-.546-2.782-1.218s1.245-1.22 2.782-1.22h717.986c1.536 0 2.782.547 2.782 1.22s-1.246 1.218-2.782 1.218Z",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M564.677 489.461a10.094 10.094 0 0 1 1.41.788l44.853-19.143 1.6-11.816 17.922-.11-1.059 27.099-59.2 15.656a10.608 10.608 0 0 1-.447 1.208 10.235 10.235 0 1 1-5.08-13.682Zm72.303 245.56h-12.26l-5.832-47.288 18.094.001-.002 47.287z",
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M615.963 731.518h23.644v14.887h-38.531a14.887 14.887 0 0 1 14.887-14.887Z",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "m684.66 731.557-12.201 1.202-10.441-46.488 18.007-1.774 4.635 47.06z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m663.401 730.131 23.53-2.318 1.46 14.816-38.346 3.776a14.887 14.887 0 0 1 13.356-16.274Z",
    fill: "#2f2e41"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 640.393,
    cy: 384.574,
    r: 24.561,
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M621.98 725.458a4.47 4.47 0 0 1-4.415-3.697c-6.345-35.226-27.088-150.406-27.584-153.596a1.427 1.427 0 0 1-.015-.222v-8.588a1.489 1.489 0 0 1 .279-.872l2.74-3.838a1.478 1.478 0 0 1 1.144-.625c15.622-.732 66.784-2.878 69.256.21 2.482 3.103 1.605 12.506 1.404 14.36l.01.193 22.985 146.995a4.512 4.512 0 0 1-3.715 5.135l-14.356 2.365a4.521 4.521 0 0 1-5.026-3.092c-4.44-14.189-19.329-61.918-24.489-80.387a.5.5 0 0 0-.98.138c.258 17.606.88 62.524 1.095 78.038l.024 1.67a4.518 4.518 0 0 1-4.093 4.537l-13.844 1.257c-.14.013-.281.019-.42.019Z",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 99",
    d: "M624.804 418.793c-4.285 2.548-6.85 7.23-8.322 11.995a113.681 113.681 0 0 0-4.884 27.16l-1.556 27.6-19.255 73.17c16.689 14.12 26.315 10.911 48.78-.64s25.033 3.852 25.033 3.852l4.492-62.259 6.419-68.032a30.164 30.164 0 0 0-4.862-4.674 49.658 49.658 0 0 0-42.442-8.995Z",
    fill: "#ffffff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M618.55 504.239a10.526 10.526 0 0 1 1.501.704l44.349-22.197.736-12.026 18.293-1.261.98 27.412-59.265 19.6a10.496 10.496 0 1 1-6.593-12.232Z",
    fill: "#ffb8b8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 101",
    d: "M675.19 431.951c10.911 3.85 12.833 45.573 12.833 45.573-12.837-7.06-28.241 4.493-28.241 4.493s-3.21-10.911-7.06-25.032a24.53 24.53 0 0 1 5.134-23.106s6.422-5.782 17.334-1.928Z",
    fill: "#ffffff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 102",
    d: "M662.415 391.069c-3.06-2.448-7.235 2.002-7.235 2.002l-2.448-22.033s-15.301 1.833-25.094-.612-11.322 8.875-11.322 8.875a78.58 78.58 0 0 1-.306-13.77c.611-5.509 8.568-11.017 22.645-14.69s21.42 12.241 21.42 12.241c9.794 4.896 5.4 30.436 2.34 27.988Z",
    fill: "#2f2e41"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.338a6354864d03f36053af1a117b957a.svg";
export { ForwardRef as ReactComponent };